import React from "react";

function DoorIntro() {
    return (
        <div>
            <h2>Introduction to Door Supervision</h2>
            <p>
                The role of a Door Supervisor is critical in maintaining safety and order in licensed premises such as nightclubs, bars, and events. This module introduces the responsibilities, legal framework, and professional standards expected of SIA-licensed Door Supervisors.
            </p>

            <h3>Key Responsibilities</h3>
            <ul>
                <li>Controlling entry and exit of premises</li>
                <li>Ensuring the safety of patrons and staff</li>
                <li>Preventing and managing conflict</li>
                <li>Monitoring crowd behavior and capacity</li>
                <li>Responding to emergencies and incidents</li>
            </ul>

            <h3>Legal Framework</h3>
            <p>
                Door Supervisors operate under several key pieces of legislation:
            </p>
            <ul>
                <li><strong>Private Security Industry Act 2001</strong> – Establishes the SIA and licensing requirements</li>
                <li><strong>Licensing Act 2003</strong> – Governs alcohol licensing and responsibilities on licensed premises</li>
                <li><strong>Health and Safety at Work Act 1974</strong> – Ensures safety for all individuals on site</li>
                <li><strong>Human Rights Act 1998</strong> – Protects individual freedoms and dignity</li>
            </ul>

            <h3>Skills and Attributes</h3>
            <ul>
                <li>Strong communication and observation skills</li>
                <li>Calm under pressure and able to defuse conflict</li>
                <li>Professional appearance and conduct</li>
                <li>Understanding of equality and diversity</li>
            </ul>

            <h3>Licensing Requirements</h3>
            <ul>
                <li>Must be 18 years or older</li>
                <li>Pass an identity and criminal background check</li>
                <li>Complete an approved SIA Door Supervisor training course</li>
                <li>Hold a valid first aid qualification (Emergency First Aid at Work or equivalent)</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/door-supervisor-licence" target="_blank" rel="noreferrer">UK Gov – Door Supervisor Licence</a></li>
                <li><a href="https://www.sia.homeoffice.gov.uk/" target="_blank" rel="noreferrer">SIA – Security Industry Authority</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Training Standards</a></li>
            </ul>
        </div>
    );
}

export default DoorIntro;
